export default __webpack_public_path__ + "static/media/sympy.0758e710.svg";